import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { scrollToOffer } from '../utils/scrollToOffer';
export function HeroSection() {
  return <section className="relative pt-8 pb-16 md:pt-12 md:pb-24 overflow-hidden bg-transparent" data-id="element-99">
      <div aria-hidden="true" className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-100">
        <div className="absolute -top-[10%] left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-[#d4a017]/5 blur-3xl" data-id="element-101" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-3xl text-center" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-6 py-2.5 mb-8 rounded-full border border-white/40 bg-[#4A553F] text-white font-semibold tracking-[0.18em] uppercase text-[8px]" data-id="element-103">
          ✨SISTEMA COMPLETO PARA PROFESIONALES DE HIGIENE Y SEGURIDAD
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-heading md:text-5xl font-extrabold text-[#2f3a2c] mb-4 text-[20px]" data-id="element-104">
          Todo lo que necesitás para brindar un servicio de Higiene y Seguridad
          profesional... ya está listo.
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mb-8" data-id="element-105">
          <img src="https://cdn.magicpatterns.com/uploads/38Zw7KxJdj8RJzWLP42Fty/Texto_del_parrafo_(10).webp" alt="Mega Pack Higiene y Seguridad Blindada" width={672} height={672} loading="eager" fetchPriority="high" decoding="async" sizes="(max-width: 768px) 100vw, 672px" className="w-full h-auto max-w-2xl mx-auto rounded-2xl shadow-2xl shadow-navy/10" data-id="element-106" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="md:text-xl text-slate-600 mb-8 max-w-2xl mx-auto text-[14px]" data-id="element-107">
          Protocolos, informes, matrices, planillas y documentos listos para
          editar, presentar y utilizar desde el primer día.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-108">
          <motion.a href="#comprar" onClick={scrollToOffer} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="flex items-center justify-center gap-3 w-full sm:w-auto bg-[#B85C43] hover:bg-[#A34F38] text-white font-bold px-8 py-4 rounded-full shadow-lg shadow-[#B85C43]/30 transition-colors mb-4 text-[19px]" data-id="element-109">
            🚀 SÍ, QUIERO EL MEGA PACK
          </motion.a>

          <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-slate-600" data-id="element-110">
            <span data-id="element-111">
              <span aria-hidden="true" data-id="element-112">⭐⭐⭐⭐⭐</span> 4.9/5 — Reseñas
              verificadas
            </span>
            <span aria-hidden="true" className="hidden sm:inline text-slate-300" data-id="element-113">
              |
            </span>
            <span data-id="element-114">
              <span aria-hidden="true" data-id="element-115">🛡️</span> Garantía de 7 Días — Riesgo
              Cero
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}